// extracted by mini-css-extract-plugin
export var date = "blog-post-preview-module--date--9sl7Z";
export var excerpt = "blog-post-preview-module--excerpt--B2yZJ";
export var inGrid = "blog-post-preview-module--inGrid--6FnzY blog-post-preview-module--root--ffk-h";
export var inList = "blog-post-preview-module--inList--lWGqv blog-post-preview-module--root--ffk-h";
export var leadMediaThumb = "blog-post-preview-module--leadMediaThumb--yRgZR";
export var root = "blog-post-preview-module--root--ffk-h";
export var text = "blog-post-preview-module--text--H5sVQ";
export var title = "blog-post-preview-module--title--yk+pN";